import React from 'react';

import { trans } from '@spotahome/soyuz/client';

import SectionHeading from '../../../common/components/SectionHeading';
import {
  SECTION_HEADING_THEME_DARK,
  SECTION_HEADING_TYPE_NONE
} from '../../refer-a-friend/common/constants';

import './HowItWorks.scss';

const HowItWorks = () => (
  <section className="ext-referral__hiw">
    <SectionHeading
      text={trans('external.buddyUp.hiw.title')}
      theme={SECTION_HEADING_TYPE_NONE}
      type={SECTION_HEADING_THEME_DARK}
    />

    <div className="ext-referral__hiw-row">
      <div className="ext-referral__hiw-item ext-referral__hiw-search">
        <span className="ext-referral__hiw-number ext-referral__hiw-number">
          1
        </span>
        <div className="ext-referral__hiw-item-wrapper">
          <h3 className="ext-referral__hiw-item-title">
            {trans('external.buddyUp.hiw.first.item.title')}
          </h3>
          <p className="ext-referral__hiw-item-desc">
            {trans('external.buddyUp.hiw.first.item.content')}
          </p>
        </div>
      </div>

      <div className="ext-referral__hiw-item ext-referral__hiw-choose">
        <span className="ext-referral__hiw-number ext-referral__hiw-number">
          2
        </span>
        <div className="ext-referral__hiw-item-wrapper">
          <h3 className="ext-referral__hiw-item-title">
            {trans('external.buddyUp.hiw.second.item.title')}
          </h3>
          <p className="ext-referral__hiw-item-desc">
            {trans('external.buddyUp.hiw.second.item.content')}
          </p>
        </div>
      </div>

      <div className="ext-referral__hiw-item ext-referral__hiw-book">
        <span className="ext-referral__hiw-number ext-referral__hiw-number">
          3
        </span>
        <div className="ext-referral__hiw-item-wrapper">
          <h3 className="ext-referral__hiw-item-title">
            {trans('external.buddyUp.hiw.third.item.title')}
          </h3>
          <p className="ext-referral__hiw-item-desc">
            {trans('external.buddyUp.hiw.third.item.content')}
          </p>
        </div>
      </div>
    </div>
  </section>
);

export default HowItWorks;
